module.exports = __webpack_public_path__ + "img/sam-and-the-brand-logo-dark.7b78421d.svg";